import {BaseComponent} from '../base/component.base.js';
import template from "./login.template.html";
import styles from "./login.styles.css";

export class LoginComponent extends BaseComponent {
    #loading = false;

    connectedCallback() {
        this.loadTemplate(template, styles);
        this.$('#login-form').addEventListener('submit', (e) => {
            e.preventDefault();
            if (this.#loading) return;
            const email = this.$('#email').value.trim();
            const password = this.$('#password').value;
            if (email && password) {
                this.emit('login-submit', {email, password});
            }
        });
    }

    setLoading(value) {
        this.#loading = value;
        const form = this.$('#login-form');
        if (!form) return;
        form.setAttribute('aria-busy', String(value));
        this.$('button[type="submit"]').disabled = value;
        this.$('#loading-overlay').hidden = !value;
    }

    /** Clears credentials when signing in or out. */
    reset() {
        this.$('#login-form')?.reset();
        this.setLoading(false);
    }
}

customElements.define('admin-login', LoginComponent);
